<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.supervisor"
        ref="RkmDataTable"
        sort-by="usuario"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="edit(item.id)"
                authorize="create-farmacia-supervisor"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                authorize="destroy-farmacia-supervisor"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            supervisor: this.getConectaSusRepository('farmacia.supervisor'),
        }
    },
    data: () => ({
        fields: [
            {name: 'unidade', key: 'unidade', label: 'Unidade', searchable: true, sortable: true},
            {name: 'infraestrutura', key: 'infraestrutura', label: 'Local de atendimento', searchable: true, sortable: true},
            {name: 'usuario', key: 'usuario', label: 'Profissional', searchable: true, sortable: true},
            {name: 'actions', key: 'actions', label: 'Ações', class: 'col-min'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({ name: 'farmacia-supervisor-edit', params: { id } })
        },
        destroy(item) {
            const destroy = () => this.repositories.supervisor.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o supervisor?', destroy)
        },
    },
    mixins: [error, repository],
}
</script>